import { Hidden, HiddenProps } from '@mui/material';
import { PropsWithChildren } from 'react';
import { Provider, ProviderProps } from 'react-redux';

export function GtHidden({
  children,
  ...props
}: PropsWithChildren<HiddenProps>) {
  return <Hidden {...props}>{children}</Hidden>;
}

export function GtProvider({
  children,
  ...props
}: PropsWithChildren<ProviderProps>) {
  return <Provider {...props}>{children}</Provider>;
}
